import { Button } from 'react-bootstrap';

const CTASection = ({ heading, primaryLabel, secondaryLabel, primaryTo, secondaryTo, children }) => {
  return (
    <div className="cta-panel">
      <h2>{heading}</h2>
      {children}
      <div className="cta-actions">
        <Button as="a" href={primaryTo} variant="primary" size="lg">
          {primaryLabel}
        </Button>
        {secondaryLabel && secondaryTo ? (
          <Button as="a" href={secondaryTo} variant="outline-light" size="lg">
            {secondaryLabel}
          </Button>
        ) : null}
      </div>
    </div>
  );
};

export default CTASection;
